import { LayoutData } from 'modules/shares/Inspector/types'

export const copyColumns = ({
  totalWidth,
  horizontalOffset,
  numberOfColumns,
  guttersOutside,
  gutterWidth,
  columnWidth,
}: LayoutData) => {
  const sectionCopyValueArray: string[] = []
  if (totalWidth) {
    sectionCopyValueArray.push(`Total Width: ${totalWidth}px`)
  }
  if (horizontalOffset) {
    sectionCopyValueArray.push(`Offset: ${horizontalOffset}px`)
  }
  if (!isNaN(numberOfColumns as number)) {
    sectionCopyValueArray.push(`Number of Columns: ${String(numberOfColumns)}`)
  }
  if (guttersOutside === true || guttersOutside === false) {
    sectionCopyValueArray.push(
      `Gutter Outside: ${guttersOutside ? `True` : `False`}`
    )
  }
  if (gutterWidth) {
    sectionCopyValueArray.push(`Gutter Width: ${gutterWidth}px`)
  }
  if (columnWidth) {
    sectionCopyValueArray.push(`Column Width: ${columnWidth}px`)
  }
  return sectionCopyValueArray.join('\n')
}

export const copyRows = ({
  gutterHeight,
  rowHeightMultiplication,
}: LayoutData) => {
  const rowHeight =
    rowHeightMultiplication && gutterHeight
      ? rowHeightMultiplication * gutterHeight
      : undefined

  let sectionCopyValue = ``
  if (gutterHeight) {
    sectionCopyValue += `Gutter Height: ${gutterHeight}px\n`
  }
  if (rowHeight) {
    sectionCopyValue += `Row Height: ${rowHeight}px`
  }
  return sectionCopyValue
}
